<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="shopForm" label-width="auto" label-position="right">
      <el-form-item label="门店名称：">
        <el-input v-model="shopForm.name" placeholder="请输入门店名称" />
      </el-form-item>
      <el-form-item label="门店微信：">
        <el-input v-model="shopForm.wechat" placeholder="请输入门店微信号" />
      </el-form-item>
      <el-form-item label="门店评分：">
        <el-input v-model="score" placeholder="请输入门店评分" />
      </el-form-item>
      <el-form-item label="微信二维码：">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
      <el-form-item label="门店地址：">
        <el-input v-model="shopForm.addr" placeholder="请输入门店地址" />
      </el-form-item>
      <el-form-item label="地图定位：">
        <div style="display: flex;justify-content: space-between; width: 100%">

<!--          <p v-if="shopForm.longitude">{{shopForm.longitude}}, {{shopForm.latitude}}</p>-->
          <p v-if="shopForm.location">{{shopForm.location}}</p>
          <el-button v-if="!shopForm.latitude" type="text" @click="openBaiduMap">获取坐标</el-button>
          <el-button v-else type="text" @click="openBaiduMap">编辑</el-button>
        </div>
<!--        <p v-if="shopForm.addr" style="color: #aaaaaa">{{shopForm.addr}} </p>-->
      </el-form-item>
      <el-form-item label="所在区域：">
        <div style="display: flex;  width: 100%;">
          <el-input v-model="shopForm.district" placeholder="请输入所在区域" style="margin-right: 8px;"/>
          <el-color-picker
              v-model="districtColor"
              :predefine="predefineColors">
          </el-color-picker>
        </div>
      </el-form-item>
      <el-form-item label="负责人：">
        <el-input v-model="shopForm.shopManager" placeholder="请输入负责人"/>
      </el-form-item>
      <el-form-item label="联系方式：">
        <el-input v-model="shopForm.contact" placeholder="请输入联系方式" :maxlength="11"/>
      </el-form-item>
      <el-form-item label="预约时间范围：">
        <div>
<!--          <el-time-select-->
<!--              v-model="shopForm.startTime"-->
<!--              :max-time="shopForm.endTime"-->
<!--              style="width: 11.2em;"-->
<!--              placeholder="开始"-->
<!--              start="07:00"-->
<!--              step="00:15"-->
<!--              end="23:45"-->
<!--          />-->
          <el-time-picker v-model="shopForm.startTime" style="width: 10em;" placeholder="开始" format="HH:mm" value-format="HH:mm"/>
          -
          <el-time-picker v-model="shopForm.endTime" style="width: 10em;" placeholder="开始" format="HH:mm" value-format="HH:mm"/>
<!--          <el-time-select-->
<!--              v-model="shopForm.endTime"-->
<!--              :min-time="shopForm.startTime"-->
<!--              style="width: 11.2em;"-->
<!--              placeholder="结束"-->
<!--              start="07:00"-->
<!--              step="00:15"-->
<!--              end="23:45"-->
<!--          />-->
        </div>

      </el-form-item>
      <el-form-item label="公开状态：">
        <el-radio-group v-model="openState" class="ml-4">
          <el-radio :label="1">公开</el-radio>
          <el-radio :label="0">不公开</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="小程序启用时间：">
        <el-date-picker
            v-model="appletOpenTime"
            type="date"
            placeholder="请选择启用日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateShop, getSysPositionList } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";
import Dialog from "@/assets/js/dialog";
import MapDialog from "@/views/shop/components/MapDialog";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      shopForm: this.value.shopForm,
      idx: this.value.ids,

      appletOpenTime: this.value.shopForm.appletOpenTime?this.value.shopForm.appletOpenTime:'',
      score: this.value.shopForm.score?this.value.shopForm.score:'',
      openState: this.value.ids > -1?this.value.shopForm.openState:1,

      files: null,
      src: this.value.shopForm.wechatImg,

      districtColor: this.value.shopForm.districtColor?this.value.shopForm.districtColor:'#1e90ff',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
      ]

    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(!this.shopForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.wechat) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店微信号不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '微信二维码不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.addr) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店地址不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.longitude || !this.shopForm.latitude) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店坐标不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.district) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '所在区域不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.shopManager) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '负责人不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.contact) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '联系方式不能为空',
          type: 'warning'
        });
        return false
      }else if(!phoneReg.test(this.shopForm.contact)){
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的联系方式',
          type: 'warning'
        });
        return false
      }
      if(!this.shopForm.startTime || !this.shopForm.endTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '预约时间范围不能为空',
          type: 'warning'
        });
        return false
      }
      // let param = {}
      //
      // param['id'] = this.idx > -1?this.shopForm.id:0;
      // param['name'] = this.shopForm.name;
      // param['addr'] = this.shopForm.addr;
      // param['shopManager'] = this.shopForm.shopManager;
      // param['contact'] = this.shopForm.contact;
      // param['startTime'] = this.shopForm.startTime;
      // param['endTime'] = this.shopForm.endTime;

      let param = new FormData();
      param.append('id', this.idx > -1?this.shopForm.id:0);
      param.append('name', this.shopForm.name);
      param.append('addr', this.shopForm.addr);
      param.append('shopManager', this.shopForm.shopManager);
      param.append('contact', this.shopForm.contact);
      param.append('startTime', this.shopForm.startTime);
      param.append('endTime', this.shopForm.endTime);
      param.append('longitude', this.shopForm.longitude);
      param.append('latitude', this.shopForm.latitude);
      param.append('location', this.shopForm.location);
      param.append('district', this.shopForm.district);
      param.append('districtColor', this.districtColor);
      param.append('wechat', this.shopForm.wechat);
      param.append('score', this.score?this.score:0);
      param.append('openState', this.openState);
      param.append('appletOpenTime', this.appletOpenTime?this.appletOpenTime:'');
      param.append('file', this.files);

      imgPostFormData(addOrUpdateShop, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getPositionList() {
      getFormData(getSysPositionList).then(data=> {
        this.positionTypeArray = data.data
      })
    },

    openBaiduMap() {
      // if(!this.shopForm.addr) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请先填写门店地址',
      //     type: 'warning'
      //   });
      //   return false
      // }
      Dialog.open({
        title: '地图',
        component: MapDialog,
        data: {
          addr: this.shopForm.addr,
          location: this.shopForm.location,
          lnglat: [this.shopForm.longitude, this.shopForm.latitude],
          width: '1000px',
        },
        confirm: (result) => {
          console.log(result)
          this.shopForm.latitude = result.lnglat.lat
          this.shopForm.longitude = result.lnglat.lng
          this.shopForm.location = result.location
          // this.shopForm.addr = result.addr
        }
      })
    }



  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
